import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: any;

  constructor() {
    const socketUrl = environment.smartHomeUrl.replace(/^http/, 'ws').replace(/\/$/, '');
    this.socket = io(socketUrl, {
      transports: ['websocket', 'polling'] // Permite WebSocket y polling
    });
    this.socket.on('connect', () => {
      console.log('[SOCKET] Conectado al servidor');
    });
    this.socket.on('connect_error', (err) => {
      console.error('[SOCKET] Error de conexión:', err);
    });
  }

  listenUnidad(unidadId: number): Observable<any> {
    return new Observable(observer => {
      const evento = `visitante_estado_unidad_${unidadId}`;
      const handler = (data) => {
        console.log(`[SOCKET] Evento recibido en servicio:`, data);
        observer.next(data);
      };
      console.log(`[SOCKET] Suscrito a evento: ${evento}`);
      this.socket.on(evento, handler);

      // Limpieza del listener al desuscribirse
      return () => {
        this.socket.off(evento, handler);
        console.log(`[SOCKET] Listener removido para: ${evento}`);
      };
    });
  }
}
